import moment from 'moment';

moment.locale('pt-br');
import 'moment/locale/pt-br';

export function formatDateToView(date: string): string {
  return moment(date).format('DD/MM/YYYY [às] HH:mm');
}
